import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Md5 } from 'ts-md5'
import { environment } from '../../../environments/environment'

@Injectable({ providedIn: 'root' })
export class UserService {
  userUrl: string
  searchUrl: string
  updatePasswordUrl: string
  manageUserStatusUrl: string
  rolesUrl: string

  constructor(private http: HttpClient) {
    const apiUrl = environment.apiUrl
    const usersApiUrl = `${apiUrl}/users`
    this.userUrl = usersApiUrl
    this.searchUrl = `${usersApiUrl}/search`
    this.updatePasswordUrl = `${usersApiUrl}/password`
    this.manageUserStatusUrl = `${usersApiUrl}/status`
    this.rolesUrl = `${apiUrl}/roles`
  }

  getUsers(params: PaginationParams) {
    const {page, size} = params;
    return this.http.get<VLSResponse>(`${this.userUrl}?searchString&page=${page}&size=${size}`)
  }

  getUserRoles() {
    return this.http.get<VLSResponse>(`${this.rolesUrl}`)
  }

  createUserRoles(role: any) {
    return this.http.post<VLSResponse>(`${this.rolesUrl}/`, role)
  }

  userDefaultValues() {
    return {
      id: '',
      username: '',
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      newPassword: '',
      confirmPassword: '',
      admin: '',
      accessToken: '',
      logonUserId: 0,
      roleIds: [],
      roles: []
    }
  }

  submitUser(user) {
    return !!user.id
      ? this.http.put<any>(`${this.userUrl}/${user.id}`, user)
      : this.http.post<any>(`${this.userUrl}/`, user)
  }

  removeUser(id) {
    return this.http.delete<any>(`${this.userUrl}/${id}`)
  }

  searchByUsernameAndEmail(searchUser: string) {
    return this.http.get<User[]>(`${this.searchUrl}?searchString=${searchUser}`)
  }

  updatePassword(user: User) {
    const postBody = {
      id: localStorage.getItem('authUserId'),
      logonUserId: parseInt(localStorage.getItem('authUserId'), 10),
      password: Md5.hashStr(user.password).toString(),
      newPassword: Md5.hashStr(user.newPassword).toString(),
      confirmPassword: Md5.hashStr(user.confirmPassword).toString(),
    }
    return this.http.post<any>(this.updatePasswordUrl, postBody)
  }

  getCurrentUserRoles() {
    const roles = localStorage.getItem('userRoles')
    return (roles && roles.split(', ')) || []
  }

  isAdmin() {
    return this.getCurrentUserRoles().includes('admin')
  }

  isOTTUser() {
    return this.getCurrentUserRoles().includes('ott')
  }

  isOTTBrUser() {
    return this.getCurrentUserRoles().includes('ottBR')
  }

  isProductDataUser() {
    return this.getCurrentUserRoles().includes('productData')
  }

  isProductDataBrUser() {
    return this.getCurrentUserRoles().includes('productDataBR')
  }

  isVODUser() {
    return this.getCurrentUserRoles().includes('vod')
  }

  isVODBrUser() {
    return this.getCurrentUserRoles().includes('vodBR')
  }

  isBrazilUser() {
    return (
      this.isOTTBrUser() || this.isProductDataBrUser() || this.isVODBrUser()
    )
  }

  hasLatamBrOTT() {
    const roles = this.getCurrentUserRoles()
    return roles.includes('ott') && roles.includes('ottBR')
  }

  hasLatamBrPD() {
    const roles = this.getCurrentUserRoles()
    return roles.includes('productData') && roles.includes('productDataBR')
  }

  hasLatamBrVOD() {
    const roles = this.getCurrentUserRoles()
    return roles.includes('vod') && roles.includes('vodBR')
  }

  hasAccessBoth() {
    return (
      this.isAdmin() ||
      this.isReadOnlyUser() ||
      this.hasLatamBrOTT() ||
      this.hasLatamBrPD() ||
      this.hasLatamBrVOD()
    )
  }

  isReadOnlyUser() {
    const roles = this.getCurrentUserRoles()
    return roles.length === 1 && roles.includes('readonly')
  }
  getPages() {
    return [
      {
        id: '5eb8e0d401dd58446d5735fc',
        name: 'Schedules',
        actions: ['Create', 'Read', 'Update', 'Delete'],
      },
      {
        id: '5eb8e0f001dd58446d5735fd',
        name: 'Programs',
        actions: ['Create', 'Read', 'Update', 'Delete'],
      },
      {
        id: '5f07f5775a42e3f358fff096',
        name: 'Program Mapping',
        actions: ['Create', 'Read', 'Update', 'Delete'],
      },
      {
        id: '5f07f5775a42e3f358fff096',
        name: 'Channel Mapping',
        actions: ['Create', 'Read', 'Update', 'Delete'],
      },
      {
        id: '5eb8e11401dd58446d5735ff',
        name: 'Reports',
        actions: ['Create', 'Read', 'Update', 'Delete'],
      },
      {
        id: '5f8a4f87db1bc040780e07b3',
        name: 'User Management',
        actions: ['Create', 'Read', 'Update', 'Delete'],
      },
    ]
  }

  getUserAction() {
    return [
      { id: "5eb8e0d401dd58446d5735fc", name: 'Create' },
      { id: '5eb8e0f001dd58446d5735fd', name: 'Read' },
      { id: '5f07f5775a42e3f358fff096', name: 'Update' },
      { id: '5f07f5775a42e3f358fff096', name: 'Delete' },
      { id: '5eb8e11401dd58446d5735ff', name: 'Publish' },
      { id: '5f8a4f87db1bc040780e07b3', name: 'Copy' },
    ]
  }
}
